import { render, staticRenderFns } from "./DetailsNameTable.vue?vue&type=template&id=fb1ba566&scoped=true"
import script from "./DetailsNameTable.vue?vue&type=script&lang=js"
export * from "./DetailsNameTable.vue?vue&type=script&lang=js"
import style0 from "./DetailsNameTable.vue?vue&type=style&index=0&id=fb1ba566&prod&scoped=true&lang=css"
import style1 from "./DetailsNameTable.vue?vue&type=style&index=1&id=fb1ba566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1ba566",
  null
  
)

export default component.exports